export const paymentSampleData = {
  list: [
    {
      id: '8',
      hash: '7a7wsZ6hsz9frA',
      currency: 'USD',
      amount: 39518.01,
      invoices: [
        {
          id: 11,
          hash: 'Qx01vSJkzG3FbH',
          currency: 'USD',
          status: 'CLOSED',
          invoice_no: 'I0011',
          invoice_title: 'I0011',
          invoice_url: null,
          balance_due_amount_base_currency: 0,
          balance_due_amount: 0,
          amount_base_currency: 47681.09,
          due_date: '2023-10-01',
          status_updated_date: '2023-10-01T00:00:00+0000',
          invoice_date: '2023-08-17',
          customer_id: 1,
          customer_name: null,
          invoice_attachment_id: null,
          created_by: {
            id: 1,
            hash: 'W3lhn4FkF45Kxo',
            email: 'vignesh.iyappan@growfin.ai',
            first_name: 'vignesh.iyappan',
            last_name: 'Iyappan',
          },
          created_date: '2024-05-16T05:47:21+0000',
          amount_applied: null,
          amount_applied_base_currency: null,
          amount_unapplied: null,
          amount_unapplied_base_currency: null,
          other_charges_amount: null,
          other_charges_amount_base_currency: null,
        },
        {
          id: 28,
          hash: 'Qx01vSJkzG3FbH',
          currency: 'USD',
          status: 'CLOSED',
          invoice_no: 'I0028',
          invoice_title: 'I0028',
          invoice_url: null,
          balance_due_amount_base_currency: 0,
          balance_due_amount: 0,
          amount_base_currency: 47681.09,
          due_date: '2023-10-01',
          status_updated_date: '2023-10-01T00:00:00+0000',
          invoice_date: '2023-08-17',
          customer_id: 1,
          customer_name: null,
          invoice_attachment_id: null,
          created_by: {
            id: 1,
            hash: 'W3lhn4FkF45Kxo',
            email: 'vignesh.iyappan@growfin.ai',
            first_name: 'vignesh.iyappan',
            last_name: 'Iyappan',
          },
          created_date: '2024-05-16T05:47:21+0000',
          amount_applied: null,
          amount_applied_base_currency: null,
          amount_unapplied: null,
          amount_unapplied_base_currency: null,
          other_charges_amount: null,
          other_charges_amount_base_currency: null,
        },
        {
          id: 17,
          hash: 'Qx01vSJkzG3FbH',
          currency: 'USD',
          status: 'CLOSED',
          invoice_no: 'I0017',
          invoice_title: 'I0017',
          invoice_url: null,
          balance_due_amount_base_currency: 0,
          balance_due_amount: 0,
          amount_base_currency: 47681.09,
          due_date: '2023-10-01',
          status_updated_date: '2023-10-01T00:00:00+0000',
          invoice_date: '2023-08-17',
          customer_id: 1,
          customer_name: null,
          invoice_attachment_id: null,
          created_by: {
            id: 1,
            hash: 'W3lhn4FkF45Kxo',
            email: 'vignesh.iyappan@growfin.ai',
            first_name: 'vignesh.iyappan',
            last_name: 'Iyappan',
          },
          created_date: '2024-05-16T05:47:21+0000',
          amount_applied: null,
          amount_applied_base_currency: null,
          amount_unapplied: null,
          amount_unapplied_base_currency: null,
          other_charges_amount: null,
          other_charges_amount_base_currency: null,
        },
      ],
      mode: 'ACH',
      customer: {
        id: 1,
        hash: '8OW1A3ZKSmDtIe',
        name: 'Peace Inc',
        adp: 77,
        currency: 'USD',
        owner: {
          id: 5,
          hash: 'txDk5n98K8Wl2q',
          email: 'abdul.freeman@growfin.ai',
          first_name: 'Abdul',
          last_name: 'Freeman',
          designation: 'Collection Owner',
        },
        address: {
          address1: 'City Hall, Room 162',
          address2: '1 Dr. Carlton B. Goodlett Place',
          city: 'San Francisco',
          state: 'California',
          country: 'United States',
          zipcode: '94102',
          type: 'CUSTOMER',
        },
        source_customer_id: '1',
        unapplied_credit_amount: 0,
        unapplied_credit_amount_base_currency: 100,
        unapplied_payment_amount: 0,
        unapplied_payment_amount_base_currency: 50,
        open_invoices_balance_amount: 0,
        open_invoices_balance_amount_base_currency: 144334.72,
        outstanding_amount: 0,
        outstanding_amount_base_currency: 144184.72,
        strategy_status: 'NOT_ASSIGNED',
        unpaid_invoice_count: 4,
        flagged_invoice_count: 0,
        last_activity_type: 'DISPUTE_OPEN',
        last_activity_date: '2024-06-11T14:52:38+0000',
        credit_term: '45',
        business_unit: {
          id: 1,
          name: 'Sales - APAC',
          deleted: false,
        },
        region: {
          id: 2,
          name: 'MENA',
          currency: 'USD',
          deleted: false,
          time_zone: null,
        },
      },
      status: 'FULLY_APPLIED',
      payment_date: '2023-10-20 00:00:00',
      amount_base_currency: 39518.01,
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_at: '2024-05-16T05:47:28+0000',
      updated_at: '2024-05-16T05:47:28+0000',
      reconciled_by: {
        id: 5,
        hash: 'txDk5n98K8Wl2q',
        email: 'abdul.freeman@growfin.ai',
        first_name: 'Abdul',
        last_name: 'Freeman',
        designation: 'Collection Owner',
      },
      notes: 'Full payment done. Pls acknowlege after receiving',
      reference_no: null,
      amount_customer_currency_data: {
        value: 39518.01,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 39518.01,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_data: {
        value: 39518.01,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 39518.01,
            currency: 'USD',
            value_in_transformed_currency: 39518.01,
            transformed_currency: 'USD',
          },
        ],
      },
      amount_customer_currency: null,
      applied_amount: 47681.09,
      applied_amount_data: {
        value: 47681.09,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 47681.09,
            currency: 'USD',
            value_in_transformed_currency: 47681.09,
            transformed_currency: 'USD',
          },
        ],
      },
      un_applied_amount_data: {
        value: 47681.09,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 47681.09,
            currency: 'USD',
            value_in_transformed_currency: 47681.09,
            transformed_currency: 'USD',
          },
        ],
      },
      unapplied_amount: 47681.09,
      applied_amount_base_currency: 47681.09,
      unapplied_amount_base_currency: 47681.09,
      other_charges_amount_base_currency: 0,
      other_charges_amount: 0,
      comments: null,
      comment_count: null,
      type: 'PAYMENT',
      subsidiary: null,
    },
    {
      id: '1',
      hash: '6Q2Kur9uv4ZHKz',
      currency: 'USD',
      amount: 45676.27,
      invoices: [
        {
          id: 1,
          hash: '2zHmr4nPgeC4Rx',
          currency: 'USD',
          status: 'DISPUTE',
          invoice_no: 'I0001',
          invoice_title: 'I0001',
          invoice_url: null,
          balance_due_amount_base_currency: 100,
          balance_due_amount: 100,
          amount_base_currency: 33349.41,
          due_date: '2024-05-11',
          status_updated_date: '2024-06-11T14:52:38+0000',
          invoice_date: '2024-03-27',
          customer_id: 1,
          customer_name: null,
          invoice_attachment_id: null,
          created_by: {
            id: 1,
            hash: 'W3lhn4FkF45Kxo',
            email: 'vignesh.iyappan@growfin.ai',
            first_name: 'vignesh.iyappan',
            last_name: 'Iyappan',
          },
          created_date: '2024-05-16T05:47:21+0000',
          amount_applied: null,
          amount_applied_base_currency: null,
          amount_unapplied: null,
          amount_unapplied_base_currency: null,
          other_charges_amount: null,
          other_charges_amount_base_currency: null,
        },
      ],
      mode: 'ACH',
      customer: {
        id: 1,
        hash: '8OW1A3ZKSmDtIe',
        name: 'Peace Inc',
        adp: 77,
        currency: 'USD',
        owner: {
          id: 5,
          hash: 'txDk5n98K8Wl2q',
          email: 'abdul.freeman@growfin.ai',
          first_name: 'Abdul',
          last_name: 'Freeman',
          designation: 'Collection Owner',
        },
        address: {
          address1: 'City Hall, Room 162',
          address2: '1 Dr. Carlton B. Goodlett Place',
          city: 'San Francisco',
          state: 'California',
          country: 'United States',
          zipcode: '94102',
          type: 'CUSTOMER',
        },
        source_customer_id: '1',
        unapplied_credit_amount: 0,
        unapplied_credit_amount_base_currency: 100,
        unapplied_payment_amount: 0,
        unapplied_payment_amount_base_currency: 50,
        open_invoices_balance_amount: 0,
        open_invoices_balance_amount_base_currency: 144334.72,
        outstanding_amount: 0,
        outstanding_amount_base_currency: 144184.72,
        strategy_status: 'NOT_ASSIGNED',
        unpaid_invoice_count: 4,
        flagged_invoice_count: 0,
        last_activity_type: 'DISPUTE_OPEN',
        last_activity_date: '2024-06-11T14:52:38+0000',
        credit_term: '45',
        business_unit: {
          id: 1,
          name: 'Sales - APAC',
          deleted: false,
        },
        region: {
          id: 2,
          name: 'MENA',
          currency: 'USD',
          deleted: false,
          time_zone: null,
        },
      },
      status: 'PARTIALLY_APPLIED',
      payment_date: '2023-11-05 00:00:00',
      amount_base_currency: 45676.27,
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_at: '2024-05-16T05:47:27+0000',
      updated_at: '2024-05-16T05:47:27+0000',
      reconciled_by: {
        id: 5,
        hash: 'txDk5n98K8Wl2q',
        email: 'abdul.freeman@growfin.ai',
        first_name: 'Abdul',
        last_name: 'Freeman',
        designation: 'Collection Owner',
      },
      notes: 'Payment made in Full',
      reference_no: null,
      amount_customer_currency_data: {
        value: 45676.27,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 45676.27,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_data: {
        value: 45676.27,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 45676.27,
            currency: 'USD',
            value_in_transformed_currency: 45676.27,
            transformed_currency: 'USD',
          },
        ],
      },
      amount_customer_currency: null,
      applied_amount: 33349.41,
      applied_amount_data: {
        value: 33349.41,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 33349.41,
            currency: 'USD',
            value_in_transformed_currency: 33349.41,
            transformed_currency: 'USD',
          },
        ],
      },
      un_applied_amount_data: {
        value: 33349.41,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 33349.41,
            currency: 'USD',
            value_in_transformed_currency: 33349.41,
            transformed_currency: 'USD',
          },
        ],
      },
      unapplied_amount: 33349.41,
      applied_amount_base_currency: 33349.41,
      unapplied_amount_base_currency: 33349.41,
      other_charges_amount_base_currency: 0,
      other_charges_amount: 0,
      comments: null,
      comment_count: null,
      type: 'PAYMENT',
      subsidiary: null,
    },
  ],
  total_records: 9,
  current_page: 1,
  total_pages: 5,
};
